import React from 'react';


const Layers = ({ data }) => {
	return [
        // {
        //   "id": "pipelineFill",
        //   "type": "fill",
        //   "paint": {
        //     "fill-color": [
        //       "get",
        //       "color"
        //     ],
        //     "fill-outline-color": [
        //       "get",
        //       "stroke"
        //     ]
        //   },
        //   "filter": [
        //     "all",
        //     [
        //       "==",
        //       [
        //         "geometry-type"
        //       ],
        //       "Polygon"
        //     ],
        //     [
        //       "!",
        //       [
        //         ">",
        //         [
        //           "get",
        //           "_height"
        //         ],
        //         0
        //       ]
        //     ]
        //   ],
        //   "source": {
        //     "data": data,
        //     "type": "geojson"
        //   }
        // },
        // {
        //   "id": "line-layer",
        //   "type": "line",
        //   "paint": {
        //     "line-color": [
        //       "get",
        //       "stroke"
        //     ],
        //     "line-width": [
        //       "interpolate",
        //       [
        //         "exponential",
        //         2
        //       ],
        //       [
        //         "zoom"
        //       ],
        //       8,
        //       [
        //         "*",
        //         [
        //           "get",
        //           "strokeWidth"
        //         ],
        //         0.002
        //       ],
        //       19,
        //       [
        //         "*",
        //         [
        //           "get",
        //           "strokeWidth"
        //         ],
        //         4
        //       ]
        //     ]
        //   },
        //   "filter": [
        //     "all",
        //     [
        //       "==",
        //       [
        //         "geometry-type"
        //       ],
        //       "LineString"
        //     ],
        //     [
        //       "!=",
        //       [
        //         "downcase",
        //         [
        //           "case",
        //           [
        //             "has",
        //             "usage"
        //           ],
        //           [
        //             "get",
        //             "usage"
        //           ],
        //           ""
        //         ]
        //       ],
        //       "road"
        //     ]
        //   ],
        //   "source": {
        //     "data": data,
        //     "type": "geojson"
        //   }
        // },
        // {
        //   "id": "pipelineRoad",
        //   "type": "line",
        //   "paint": {
        //     "line-color": "grey",
        //     "line-width": [
        //       "interpolate",
        //       [
        //         "exponential",
        //         2
        //       ],
        //       [
        //         "zoom"
        //       ],
        //       8,
        //       [
        //         "*",
        //         [
        //           "get",
        //           "roadWidth"
        //         ],
        //         0.02
        //       ],
        //       19,
        //       [
        //         "*",
        //         [
        //           "get",
        //           "roadWidth"
        //         ],
        //         40
        //       ]
        //     ]
        //   },
        //   "filter": [
        //     "all",
        //     [
        //       "==",
        //       [
        //         "geometry-type"
        //       ],
        //       "LineString"
        //     ],
        //     [
        //       "==",
        //       [
        //         "downcase",
        //         [
        //           "get",
        //           "usage"
        //         ]
        //       ],
        //       "road"
        //     ]
        //   ],
        //   "source": {
        //     "data": data,
        //     "type": "geojson"
        //   }
        // },
        {
          "id": "3d-building-layer",
          "type": "fill-extrusion",
          "paint": {
            "fill-extrusion-base": [
              "get",
              "_baseHeight"
            ],
            // "fill-extrusion-color": [
            //   "get",
            //   "color"
            // ],
            "fill-extrusion-color": [
              "match",
              ["get", "urb_project_status"],
              "proposed",['to-color', 'rgb(80,175,222)'],
              "approved", ['to-color', 'rgb(76,156,142)'],
              "construction", ['to-color', 'rgb(221,202,88)'],
              "under_construction", ['to-color', 'rgb(221,202,88)'],
              "completed", ['to-color', 'rgb(183,97,166)'],
              "cancelled", ['to-color', 'rgb(207,214,211)'],
             ['to-color', "#fff"]
            ],
            "fill-extrusion-height": [
              "get",
              "_height"
            ]
          },
          "filter": [
            "all",
            [
              "==",
              [
                "geometry-type"
              ],
              "Polygon"
            ],
            [
              ">",
              [
                "get",
                "_height"
              ],
              0
            ]
          ],
          "source": {
            "data": data,
            "type": "geojson"
          }
        },{
        "id": "3d-building-layer-selected",
        "type": "fill-extrusion",
        "paint": {
          "fill-extrusion-base": [
            "get",
            "_baseHeight"
          ],
          "fill-extrusion-color": [
            "match",
            ["get", "urb_project_status"],
            // d3.rgb(darken('rgb(80,175,222)')).hex() on above https://observablehq.com/@d3/working-with-color?collection=@d3/d3-color
            "proposed",['to-color', "#0080ac"],
            "approved", ['to-color', "#156d61"],
            "construction", ['to-color', "#a99926"],
            "under_construction", ['to-color', "#a99926"],
            "completed", ['to-color', "#853377"],
            "cancelled", ['to-color', "#9ea5a2"],
           ['to-color', "#fff"]
          ],
          "fill-extrusion-height": [
            "get",
            "_height"
          ]
        },
        "filter": [
          "all",
          ['in', 'id', ["literal", []]],
          [
            "==",
            [
              "geometry-type"
            ],
            "Polygon"
          ],
          [
            ">",
            [
              "get",
              "_height"
            ],
            0
          ]
        ],
        "source": {
          "data": data,
          "type": "geojson"
        }
      },
      ]
}


export default Layers;